export default __webpack_public_path__ + "static/media/FacebookMessenger.14908969.svg";